import { Link } from 'react-router-dom'
import { useState } from 'react'
import { ISection, IMenu } from '../../../../types/menu'
import { ChevronRight } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

interface Props {
	section: ISection
	onClose?: () => void
}

export function SubItemMenuNav({ section, onClose }: Props) {
	const [isOpen, setIsOpen] = useState(false)

	const hasMenus = !!section.menus && section.menus.length > 0

	return (
		<div className="flex flex-col mb-1 last:mb-0">
			<button
				onClick={() => hasMenus && setIsOpen(!isOpen)}
				className={`flex items-center justify-between w-full py-3 px-3 rounded-xl transition-all border-none cursor-pointer text-left
          ${isOpen ? 'bg-primary/5 dark:bg-white/5' : 'bg-transparent hover:bg-surface-alt dark:hover:bg-white/5'}
        `}
			>
				<div className="flex items-center gap-3">
					<div className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${isOpen ? 'bg-secondary scale-125' : 'bg-border-default dark:bg-border-default-dark'}`} />
					<span className={`text-xs font-bold uppercase tracking-wider transition-colors ${isOpen ? 'text-primary dark:text-secondary' : 'text-on-surface-subtle dark:text-on-surface-dark-muted'}`}>
						{section.titulo}
					</span>
				</div>
				{hasMenus && (
					<ChevronRight
						size={16}
						className={`text-on-surface-subtle/50 dark:text-on-surface-dark-muted/50 transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}
					/>
				)}
			</button>

			<AnimatePresence>
				{isOpen && hasMenus && (
					<motion.div
						initial={{ height: 0, opacity: 0 }}
						animate={{ height: "auto", opacity: 1 }}
						exit={{ height: 0, opacity: 0 }}
						transition={{ duration: 0.3, ease: "easeInOut" }}
						className="overflow-hidden"
					>
						<ul className="m-0 py-2 pl-6 pr-2 list-none flex flex-col gap-1 border-l-2 border-border-default/20 dark:border-border-default-dark/20 ml-3.5 mt-1">
							{section.menus?.map((item: IMenu, index: number) => {
								let subMenuNav_link = '#'
								let isInternal = false

								if (item.link === 'noticias') { subMenuNav_link = '/noticias'; isInternal = true; }
								else if (item.link === 'contato') { subMenuNav_link = '/contato'; isInternal = true; }
								else if (item.link === 'localizacao') { subMenuNav_link = '/localizacao'; isInternal = true; }
								else if (item.link === 'telefones') { subMenuNav_link = '/telefones'; isInternal = true; }
								else if (item.ref_cod_artigo) {
									subMenuNav_link = '/a/' + item.ref_cod_artigo
									isInternal = true
								} else if (item.ref_cod_entidade) {
									subMenuNav_link = '/e/' + item.ref_cod_entidade
									isInternal = true
								} else if (item.link) {
									subMenuNav_link = item.link
								}

								let subMenuNav_target = item.nova_janela ? '_blank' : '_self'

								return (
									<li key={index}>
										{isInternal ? (
											<Link
												to={subMenuNav_link}
												onClick={onClose}
												className="text-on-surface dark:text-on-surface-dark text-[0.8125rem] font-medium py-2.5 px-4 block rounded-xl hover:bg-surface-alt dark:hover:bg-white/5 no-underline transition-all active:scale-[0.98] border-none"
											>
												{item.titulo}
											</Link>
										) : (
											<a
												href={subMenuNav_link}
												target={subMenuNav_target}
												onClick={() => {
													if (subMenuNav_target !== '_blank') {
														onClose?.()
													}
												}}
												rel={subMenuNav_target === '_blank' ? "noreferrer" : ""}
												className="text-on-surface dark:text-on-surface-dark text-[0.8125rem] font-medium py-2.5 px-4 block rounded-xl hover:bg-surface-alt dark:hover:bg-white/5 no-underline transition-all active:scale-[0.98] border-none"
											>
												{item.titulo}
											</a>
										)}
									</li>
								)
							})}
						</ul>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	)
}